/**
 * Testo del campo di ricerca delle pagine elenco, conservato al refresh.
 *
 * Una chiave per pagina (il path della rotta, es. `reach/audiences`), così la ricerca di una pagina
 * non compare nelle altre. Sta in `sessionStorage`: sopravvive al refresh ma resta legata alla
 * scheda, e al logout viene svuotato insieme al resto (vedi `AuthService`).
 *
 * Engine e Console sono servite dallo stesso origin e quindi condividono `sessionStorage`: il
 * prefisso `engine.` tiene separate pagine con lo stesso nome (`/reach/audiences` qui,
 * `/console/audiences` su Console). Gemello di `src/app/utils/persisted-search.ts` su Console, che
 * usa il prefisso `console.`.
 */

const KEY_PREFIX = 'engine.search.';

export function loadSearch(page: string): string {
  try {
    return sessionStorage.getItem(KEY_PREFIX + page) ?? '';
  } catch {
    return '';
  }
}

export function saveSearch(page: string, term: string): void {
  try {
    if (term) {
      sessionStorage.setItem(KEY_PREFIX + page, term);
    } else {
      sessionStorage.removeItem(KEY_PREFIX + page);
    }
  } catch {
    // Storage non disponibile (es. navigazione privata con quota zero): la ricerca resta solo in memoria.
  }
}
